import LocalizedStrings from "react-localization";

export default new LocalizedStrings({
    en: {
        languageName: "Language",
        en: "English",
        fr: "Français",
        pt: "Português",
        es: "Español",
        export: 'Save locally',
        clear: 'Clear',
        privacyHint: 'By sending the form to the Rector, I acknowledge the {link} / data protection information.',
        privacyHintLinkText: 'privacy policy',
        send: 'Send to Rector',
        project: 'Seminary',
        projectNumberPlaceholder: 'Project number...',
        creationDate: 'Creation Date',
        student_priest: 'SEMINARIAN',
        lastName: 'Last Name',
        firstName: 'First Name',
        asInPassport: 'as in Passport (required)',
        asInPassportNoTitle: 'as in Passport, no titles (required)',
        required: '(required)',
        dateOfBirth: "Date of Birth",
        diocese: "Diocese",
        congregation: "Congregation",
        yearPlaceholder: "YYYY",
        yearOfTheology: "Present Year of Theology",
        yearOfAdmission: "Year of Admission (Theology)",
        pastoralYear: "Probable Pastoral Year",
        yearOfOrdinationToDiaconate: "Year of Ordination to Diaconate",
        yearOfOrdination: "Year of Ordination to Priesthood",
        languages: "Main language",
        oneFiftyInfo: "Write between 150 and 220 words",
        eightyInfo: "Write between 80 and 150 words",
        cv: "Curriculum vitae",
        cvPlaceholder: "Please describe the history in complete sentences like a short story. Please note that just a list of dates and years is not enough. These questions can be helpful: What school did you go to? What subjects did you really enjoyed? What did you contribute to your community? Where have you been before your theological studies? How do you spend your free time? What hobbies do you have? What languages do you speak?",
        background: "Family background",
        backgroundPlaceholder: "Where do you come from? What do your parents do for a living and what influence did your parents' working life had on you? How many siblings do you have? How was the faith practised in the family and how did this influence your young vocation?",
        berufung: "Why do you want to be a priest?",
        berufungPlaceholder: "How did it come about that you wanted to become a priest? Was there one event that played a decisive role in your call to the priesthood? This information is very important. A moving testimony can help Missio and our benefactors, to explain more clearly why young men wish to become priests and why it is necessary to pray for you.",
        wichtiges: "What is important to you?",
        wichtigesPlaceholder: "This section gives you the opportunity to state your own personal wishes for your family, your country and your vocation. You are also invited to express prayer intentions. We urge students to find the courage to talk openly about the future, the dreams and the visions. Combined with the testimony about your vocation this forges an important link between the benefactor and the seminarian, enabling the benefactor to remember the student in his or her prayers in a very specific manner.",
        sonstiges: "Remarks",
        sonstigesPlaceholder: "In this section, you are especially encouraged to include prayers and intentions for your benefactor. This space may also be used for additional personal remarks or special requests.",
        choose_file: "Choose file...",
        browse: "Browse",
        profile: "Photo",
        photoExplanation: "The photo is especially important for a benefactor's first impression of the student. Please note the following:",
        photoExplanation1: "The photo should be a <strong>portrait</strong> and <strong>pre-cropped</strong> (format 2:3 or 3:4).",
        photoExplanation2: "Ideally, the student should wear a <strong>cassock</strong>.",
        photoExplanation3: "Students should <strong>not wear sunglasses</strong>.",
        photoExplanation4: "It should <strong>not be a selfie</strong>.",
        photoExplanation5: "The student should have a <strong>friendly smile</strong>.",
        photoExplanation6: "The <strong>background</strong> should be <strong>natural</strong> (e.g. outdoors in nature).",
        photoExplanation7: "The photo should be of <strong>good quality (HD)</strong>.",
        photoExplanation8: "<strong>Do not reduce the file size</strong> if it is already smaller than 2MB.",
        import: "Import",
        xmlImportDescription: "To edit a seminarian, upload an exported XML file here.",
        errorMissingUpload: "Please upload a Profile Picture",
        errorGebdat: 'Please set a Date of Birth',
        errorProjektnummer: 'Please choose a Project',
        errorDioezese: 'Please choose a Diocese',
        errorIsRequired: 'Please fill out this field',
        statusSuccess: 'Success',
        statusFailed: 'Failed'
    },

    fr: {
        languageName: "Langue",
        en: "English",
        fr: "Français",
        pt: "Português",
        es: "Español",
        export: 'Sauvegarder localement',
        clear: 'Effacer',
        privacyHint: 'En envoyant le formulaire au recteur, je confirme avoir pris connaissance de la {link} / protection des données.',
        privacyHintLinkText: 'déclaration de confidentialité',
        send: 'Envoyer au Recteur',
        project: 'Séminaire',
        projectNumberPlaceholder: 'Numéro du Projet...',
        creationDate: 'Date de création',
        student_priest: 'SÉMINARISTE',
        lastName: 'Nom de Famille',
        firstName: 'Prénom',
        asInPassport: 'Comme dans Passeport (obligatoire)',
        asInPassportNoTitle: 'Comme dans Passeport (obligatoire)',
        required: '(obligatoire)',
        dateOfBirth: "Date de naissance",
        diocese: "Diocèse",
        congregation: "Congrégation",
        yearPlaceholder: "AAAA",
        yearOfTheology: "Année actuelle de théologie",
        yearOfAdmission: "Année d’admission (théologie)",
        pastoralYear: "Année pastorale probable",
        yearOfOrdinationToDiaconate: "Année d’ordination au diaconat",
        yearOfOrdination: "Année d'ordination sacerdotale",
        languages: "Langue de correspondance",
        oneFiftyInfo: "Écrivez entre 150 et 220 mots",
        eightyInfo: "Écrivez entre 80 et 150 mots",
        cv: "Curriculum vitae",
        cvPlaceholder: "Veuillez décrire l’histoire en phrases complètes comme un court récit. Veuillez noter qu’une simple liste de dates et d’années ne suffit pas. Ces questions peuvent être utiles: Quelle école avez-vous fréquentée? Quelles matières à l’école avez-vous vraiment aimé à l’école? Quelle contribution avez-vous apportée à votre communauté? Comment occupiez-vous votre temps libre? Où étiez-vous avant vos études théologiques? Quelles langues parlez-vous ?",
        background: "Antécédents familiaux",
        backgroundPlaceholder: "D’où venez-vous? Que font vos parents dans la vie et quelle influence la vie professionnelle de vos parents a-t-elle eue sur vous? Combien de frères et sœurs avez-vous?  Comment la foi a-t-elle été pratiquée dans la famille et comment cela a-t-il influencé votre jeune vocation?",
        berufung: "Pourquoi voulez-vous être prêtre?",
        berufungPlaceholder: "Comment vous êtes-vous arrivé de vouloir devenir prêtre? Y a-t-il un événement qui a joué un rôle décisif dans votre appel à la prêtrise? Cette information est très importante. Un témoignage émouvant peut aider Missio et nos bienfaiteurs à expliquer plus clairement pourquoi les jeunes gens souhaitent devenir prêtres et pourquoi il est nécessaire de prier pour vous.",
        wichtiges: "Qu’est-ce qui est important pour vous?",
        wichtigesPlaceholder: "Cette section vous donne l’occasion d’exprimer vos souhaits personnels pour votre famille, votre pays et votre vocation. Vous êtes également invités à exprimer vos intentions de prière. Nous exhortons les étudiants à trouver le courage de parler ouvertement de l’avenir, des rêves et des visions. Combiné au témoignage de votre vocation, cela forge un lien important entre le bienfaiteur et le séminariste, permettant au bienfaiteur de se souvenir de l’étudiant dans ses prières d’une manière très spécifique.",
        sonstiges: "Remarques",
        sonstigesPlaceholder: "Dans cette section, vous êtes spécialement encouragé à inclure des prières et des intentions pour votre bienfaiteur. Cet espace peut également être utilisé pour des remarques personnelles supplémentaires ou des intentions particulières.",
        choose_file: "Choisir le fichier...",
        browse: "Parcourir",
        profile: "Photo",
        photoExplanation: "La photo est particulièrement importante pour la première impression du bienfaiteur. Veuillez noter ce qui suit:",
        photoExplanation1: "La photo doit être un <strong>portrait</strong> et <strong>pré-recadrée</strong> (format 2:3 ou 3:4).",
        photoExplanation2: "Idéalement, l'étudiant devrait porter une <strong>soutane</strong>.",
        photoExplanation3: "Les étudiants <strong>ne doivent pas porter de lunettes de soleil</strong>.",
        photoExplanation4: "Il <strong>ne doit pas s'agir d'un selfie</strong>.",
        photoExplanation5: "L'étudiant doit avoir un <strong>sourire amical</strong>.",
        photoExplanation6: "<strong>L'arrière-plan doit être naturel</strong> (par exemple, en plein air, dans la nature).",
        photoExplanation7: "La photo doit être de <strong>bonne qualité (HD)</strong>.",
        photoExplanation8: "<strong>Ne réduisez pas la taille du fichier</strong> s'il est déjà inférieur à 2 MB.",
        import: "Importation",
        xmlImportDescription: "Pour éditer un séminariste, téléchargez un fichier exporté XML ici:",
        errorMissingUpload: "Veuillez télécharger une photo de profil",
        errorGebdat: 'Veuillez indiquer une date de naissance',
        errorProjektnummer: 'Veuillez choisir un projet',
        errorDioezese: 'Veuillez choisir un diocèse',
        errorIsRequired : 'Veuillez remplir ce champ',
        statusSuccess : 'Succès!',
        statusFailed : "Échec!"
    },

    pt: {
        languageName: "Língua",
        en: "English",
        fr: "Français",
        pt: "Português",
        es: "Español",
        export: 'Guardar localmente',
        clear: 'Deletar',
        privacyHint: 'Enviando o formulário ao Reitor, reconheço a {link} / Informações sobre proteção de dados.',
        privacyHintLinkText: 'política de privacidade',
        send: 'Enviar ao Reitor',
        project: 'Seminário',
        projectNumberPlaceholder: 'Número do projeto...',
        creationDate: 'Data da Criação',
        student_priest: 'SEMINARISTA',
        lastName: 'Apelido',
        firstName: 'Primeiro Nome',
        asInPassport: 'Tal como no Passaporte (obrigatório)',
        asInPassportNoTitle: 'Como no Passaporte, sem títulos (obrigatório)',
        required: '(obrigatório)',
        dateOfBirth: "Data de nascimento",
        diocese: "Diocese",
        congregation: "Congregação",
        yearPlaceholder: "AAAA",
        yearOfTheology: "Ano Presente de Teologia",
        yearOfAdmission: "Ano de Admissão (Teologia)",
        pastoralYear: "Provável Ano Pastoral",
        yearOfOrdinationToDiaconate: "Ano de Ordenação à Diaconato",
        yearOfOrdination: "Ano de Ordenação ao Sacerdócio",
        languages: "Idioma de correspondência",
        oneFiftyInfo: "Escreva entre 150 e 2​20 palavras",
        eightyInfo: "Escreva entre 80 e 150 palavras",
        cv: "Curriculum vitae",
        cvPlaceholder: "Por favor, descreva a história em frases completas como um conto. Por favor, note que apenas uma lista de datas e anos não é suficiente. Estas questões podem ser úteis: Em que escola você estudou? Que disciplinas na escola realmente gostavam? ¿Qué aportaste a tu comunidad? Como passou o seu tempo livre? Onde esteve antes dos seus estudos teológicos? Que idiomas você fala ",
        background: "Fundo familiar",
        backgroundPlaceholder: "De onde vem? O que os teus pais fazem para viver e que influência tinha a vida profissional dos teus pais em ti? Quantos irmãos tem? Como foi praticada a fé na família e como isso influenciou a sua jovem vocação?",
        berufung: "Por que quer ser padre?",
        berufungPlaceholder: "Como é que se urgiu que tu querias ser padre? Houve algum evento que teve um papel decisivo na sua chamada ao sacerdócio? Esta informação é muito importante. Um testemunho comovente pode ajudar a Missio, e os nossos benfeitores, a explicar mais claramente porque é que os jovens querem ser padres e porque é necessário rezar por ti.",
        wichtiges: "O que é importante para ti?",
        wichtigesPlaceholder: "Esta secção dá-lhe a oportunidade de declarar os seus desejos pessoais para a sua família, o seu país e a sua vocação. Também está convidado a expressar intenções de oração. Exortamos os estudantes a encontrarem coragem para falarem abertamente sobre o futuro, os sonhos e as visões. Combinado com o testemunho sobre a sua vocação, isto forja uma ligação importante entre o benfeitor e o seminarista, permitindo ao benfeitor lembrar o estudante nas suas orações de uma forma muito específica.",
        sonstiges: "Observações",
        sonstigesPlaceholder: "Nesta seção, você é especialmente encorajado a incluir orações e intenções pelo seu benfeitor. Este espaço também pode ser utilizado para observações pessoais adicionais ou pedidos especiais.",
        choose_file: "Escolher ficheiro...",
        browse: "Navegar",
        profile: "Foto de perfil",
        photoExplanation: "A foto é particularmente importante para formar a primeira impressão que o benfeitor tem do seminarista. Por favor, siga as seguintes orientações:",
        photoExplanation1: "A foto deve ser um <strong>retrato</strong> e <strong>pré-recortada</strong> (formato 2:3 ou 3:4).",
        photoExplanation2: "Idealmente, o aluno deve usar uma <strong>batina</strong>.",
        photoExplanation3: "Os seminaristas <strong>não devem usar óculos escuros</strong>.",
        photoExplanation4: "<strong>Não deveser uma selfie.</strong>",
        photoExplanation5: "O aluno deve ter um <strong>sorriso amigável</strong>.",
        photoExplanation6: "<strong>O fundo deve ser natural</strong> (por exemplo, ao ar livre, na natureza).",
        photoExplanation7: "A foto deve ser de <strong>boa qualidade (HD)</strong>.",
        photoExplanation8: "<strong>Não reduza o tamanho do arquivo</strong> se ele já for menor que 2 MB.",
        import: "Importação",
        xmlImportDescription: "Para editar um seminarista, faça o upload do arquivo XML exportado aqui.",
        errorMissingUpload: "Carregue uma fotografia de perfil",
        errorGebdat: 'Definir uma data de nascimento',
        errorProjektnummer: 'Escolha um projeto',
        errorDioezese: 'Escolha uma diocese',
        errorIsRequired: 'Por favor, preencha este campo',
        statusSuccess: 'Sucesso!',
        statusFailed: "Falhou!"
    },

    es: {
        languageName: "Idioma",
        en: "English",
        fr: "Français",
        pt: "Português",
        es: "Español",
        export: 'Guardar localmente',
        clear: 'Borrar',
        privacyHint: 'Enviando el formulario al Rector, acepto la {link} / Información sobre protección de datos.',
        privacyHintLinkText: 'política de privacidad',
        send: 'Enviar al Rector',
        project: 'Seminario',
        projectNumberPlaceholder: 'Número de proyecto...',
        creationDate: 'Fecha de creación',
        student_priest: 'SEMINARISTA',
        lastName: 'Apellido',
        firstName: 'Nombre',
        asInPassport: 'Como en Pasaporte (obligatorio)',
        asInPassportNoTitle: 'Como en Pasaporte, sin títulos (obligatorio)',
        required: '(Obligatorio)',
        dateOfBirth: "Fecha de nacimiento",
        diocese: "Diócesis",
        congregation: "Congregación",
        yearPlaceholder: "AAAA",
        yearOfTheology: "Presente Año de la Teología",
        yearOfAdmission: "Año de admisión (teología)",
        pastoralYear: "Probable año pastoral",
        yearOfOrdinationToDiaconate: "Año de ordenación diaconal",
        yearOfOrdination: "Año de ordenación sacerdotal",
        languages: "Lengua de correspondencia",
        oneFiftyInfo: "Escriba entre 150 y 220 palabras",
        eightyInfo: "Escriba entre 80 y 150 palabras",
        cv: "Currículum",
        cvPlaceholder: "Por favor, describa la historia en oraciones completas como una historia corta. Tenga en cuenta que solo una lista de fechas y años no es suficiente. Estas preguntas pueden ser útiles: ¿A qué escuela fuiste? ¿Qué asignaturas te gustaban más? ¿Qué aportaste a tu comunidad? y en qué materias eres particularmente bueno? ¿Qué habilidades pudo aportar a su comunidad? ¿Cómo pasaste tu tiempo libre? ¿Qué pasatiempos tienes? ¿Dónde has estado antes de tus estudios teológicos ¿Qué lenguas hablas?",
        background: "Antecedentes familiares",
        backgroundPlaceholder: "¿De dónde vienes? ¿Qué hacen tus padres para ganarse la vida y qué influencia tuvo en ti la vida laboral de tus padres? ¿Cuántos hermanos tienes? ¿Cómo se practicaba la fe en la familia y cómo influyó esto en su joven vocación?",
        berufung: "¿Por qué quieres ser sacerdote?",
        berufungPlaceholder: "¿Cómo sucedió que tú quisiste ser sacerdote? ¿Hubo algún acontecimiento que haya jugado un papel decisivo en su llamado al sacerdocio? Esta información es muy importante. Un testimonio conmovedor puede ayudar a Missio, y a nuestros benefactores, a explicar más claramente por qué los jóvenes desean convertirse en sacerdotes y por qué es necesario orar por ustedes.",
        wichtiges: "¿Qué es importante para ti?",
        wichtigesPlaceholder: "Esta sección le da la oportunidad de expresar sus propios deseos personales para su  familia, su país y su vocación. También se le invita a expresar intenciones de oración. Instamos a los estudiantes a encontrar el coraje para hablar abiertamente sobre el futuro, los sueños y las visiones. Combinado con el testimonio sobre su vocación, esto forja un vínculo importante entre el benefactor y el seminarista, permitiendo al benefactor recordar al estudiante en sus oraciones de una manera muy específica.",
        sonstiges: "Algo más",
        sonstigesPlaceholder: "En esta sección, se le anima especialmente a incluir oraciones e intenciones por su benefactor. Este espacio también puede utilizarse para observaciones personales adicionales o peticiones especiales.",
        choose_file: "Elegir archivo...",
        browse: "Visite",
        profile: "Foto de perfil",
        photoExplanation: "La foto es importante, ya que ayuda a causar una buena primera impresión ante el benefactor. Siga las siguientes instrucciones:",
        photoExplanation1: "La foto debe ser un <strong>retrato</strong> y estar <strong>recortada</strong> (formato 2:3 o 3:4).",
        photoExplanation2: "Lo ideal sería que el estudiante llevara una <strong>sotana</strong>.",
        photoExplanation3: "Los estudiantes <strong>no deben llevar gafas de sol</strong>.",
        photoExplanation4: "<strong>No debería ser un selfi</strong>.",
        photoExplanation5: "El estudiante debe mostrar una <strong>sonrisa amable</strong>.",
        photoExplanation6: "El <strong>fondo debe ser natural</strong> (p. ej., al aire libre, en la naturaleza).",
        photoExplanation7: "La foto debe ser de <strong>buena calidad (HD)</strong>.",
        photoExplanation8: "<strong>No reduzca el tamaño del archivo</strong> si ya es inferior a 2 MB.",
        import: "Importación",
        xmlImportDescription: "Para editar un seminarista, cargue aquí un archivo XML exportado.",
        errorMissingUpload: "Cargue una foto de perfil",
        errorGebdat: 'Introduzca una fecha de nacimiento',
        errorProjektnummer: 'Elija un proyecto',
        errorDioezese: 'Elija una diócesis',
        errorIsRequired: 'Por favor, rellene este campo',
        statusSuccess: '¡Exito!',
        statusFailed: '¡Falló!'
        }
});